/**
 * Transition duration tokens for animations
 */
export const transitions = {
  /** Hovers, micro-interactions, toggles */
  quick: "0.2s",

  /** Page transitions, modals, expansions */
  standard: "0.3s",
} as const;

export type TransitionToken = keyof typeof transitions;
